import React from "react";
import Footer from "../Footer/Footer";
import Home from "../Home_Page/Home";
import DrawerAppBar from "../Navbar/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ConnectWallet from "../ConnectWallet_Page/ConnectWallet";
import Profile from "../Profile_Page/Profile";
import Auction from "../Live_Auction/Auction";
import ItemDetail from "../Item_Detail/ItemDetail";
import CollectionMain from "../Collection_Page/CollectionMain";
import Creator from "../Creator_Page/Creator";
import Activity from "../Activity_Page/Activity";
import Ranking from "../Ranking_Page/Ranking";
import Create from "../Create_Page/Create";

function Layout() {
  return (
    <div>
      <DrawerAppBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/connectwallet" element={<ConnectWallet />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/auction" element={<Auction />} />
        <Route path="/itemdetail" element={<ItemDetail />} />
        <Route path="/collection" element={<CollectionMain />} />
        <Route path="/creator" element={<Creator />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/ranking" element={<Ranking />} />
        <Route path="/create" element={<Create />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default Layout;
